export default import.meta.ROLLDOWN_FILE_URL("assets/teamsLogo-B4R1RLn8.png")